import type { Row } from "@rocicorp/zero";
import type { IconName } from "../../assets/icons";

export type TinesUnitsSpaceRow = {
  key: string;
  label: string;
  icon: IconName;
  total: number;
  storage: number;
  workflowCount: number;
  owner: Row["user"] | null;
  forecast?: number | null;
};

export function buildTinesUnitsSpaceRows(
  rows: readonly TinesUnitsSpaceRow[],
  matchesSpace: (spaceId: string) => boolean,
  personalIds: ReadonlySet<string>,
  foldPersonal: boolean,
  personalTemplate: TinesUnitsSpaceRow
) {
  const topRows: TinesUnitsSpaceRow[] = [];
  let personal: TinesUnitsSpaceRow | null = null;
  for (const row of rows) {
    if (!matchesSpace(row.key)) continue;
    if (foldPersonal && personalIds.has(row.key)) {
      personal ??= { ...personalTemplate };
      personal.total += row.total;
      personal.storage += row.storage;
      personal.workflowCount += row.workflowCount;
    } else {
      topRows.push(row);
    }
  }
  if (personal) topRows.push(personal);
  topRows.sort((a, b) => b.total - a.total);

  const personalRows = rows
    .filter((row) => personalIds.has(row.key))
    .sort((a, b) => b.total - a.total);

  return {
    topRows,
    personalRows,
    personalTotal: personalRows.reduce((sum, row) => sum + row.total, 0),
  };
}
